<template>
    <div class="contain desFile">
        <div class="header-box">
            制度管理
        </div>
        <div class="box">
            <div class="build-bar">
                <!-- <el-button style="margin:5px 10px;" :class="cuid=='1'?'primary':'none-buttin'" @click="setCuid(1)">销售管理</el-button> -->
                <el-button style="margin:5px 10px;" :class="cuid=='48'?'primary':'none-buttin'" @click="setCuid(48)">周工作情况</el-button>
                <el-button style="margin:5px 10px;" :class="cuid=='49'?'primary':'none-buttin'" @click="setCuid(49)">公共文件夹</el-button>
                <el-button style="margin:5px 50px 5px 10px;" :class="cuid=='4'?'primary':'none-buttin'" @click="setCuid(4)">通讯录</el-button>
                <span v-if="cuid=='1'">项目名称：</span>
                <el-input placeholder="请输入项目名称" v-model="search.name" v-if="cuid=='1'"></el-input>
                <el-button type="primary" class="add-user" @click="doFilter" v-if="cuid=='1'">查询</el-button>
                <span v-if="cuid=='4'">姓名：</span>
                <el-input placeholder="请输入责任人姓名" v-model="search.responsiblePerson" v-if="cuid=='4'" style="margin-right:30px;"></el-input>
                <span v-if="cuid=='4'">联系方式：</span>
                <el-input placeholder="请输入联系方式" v-model="search.phone" v-if="cuid=='4'"></el-input>
                <el-button type="primary" size="small" icon="el-icon-search" @click="doFilterMail" v-if="cuid=='4'">查询</el-button>
                <el-button size="small" icon="el-icon-plus" @click="addQin" v-if="cuid=='4'">添加</el-button>
                <!-- <el-button type="primary" class="add-user" @click="addFun">新增</el-button> -->
            </div>
            <div class="box-content flex-wrap" v-if="cuid=='48'||cuid=='49'">
                <div class="table-item" style="height:250px;" v-for="item in dataList" :key="item.id">
                    <!-- <div style="width:150px;" class="item-con" v-if="item.name">
                        {{item.name}}
                    </div> -->
                    <div style="flex:1;display:flex;flex-wrap: wrap;" class="item-con">
                        <div style="width:150px;display:flex;flex-wrap:wrap;align-content: flex-start;" v-for="child in item.attachments" :key="child.id">
                            <p class="title nowrap" style="width:100%;min-height: 10px;" :title="child.attachmentName">{{child.attachmentName}}</p>
                            <p  style="width:100%;">
                                <img v-if="child.fileType=='0'" style="width:60px;height:60px;" src="../../../assets/image/file.png" @click="showChild(child.id)" />
                                <img v-if="child.fileType=='1'" style="width:50px;height:50px;" src="../../../assets/image/office/word.png" @click="showFile(child.attachment,child.attachmentName)" />
                                <img v-else-if="child.fileType=='2'" style="width:50px;height:50px;" src="../../../assets/image/office/excel.png" @click="showFile(child.attachment,child.attachmentName)" />
                                <img v-else-if="child.fileType=='3'" style="width:50px;height:50px;" src="../../../assets/image/office/pdf.png" @click="showFile(child.attachment,child.attachmentName)" />
                                <img v-else-if="child.fileType=='4'" style="width:50px;height:50px;" src="../../../assets/image/office/photo.png" @click="showFile(child.attachment,child.attachmentName)" />
                                <img v-else-if="child.fileType=='5'" style="width:50px;height:50px;" src="../../../assets/image/office/undefined.png" @click="showFile(child.attachment,child.attachmentName)" />
                            </p>
                            <p v-if="child.fileType!='0'" style="width:100%;"><img style="width:40px;height:40px;" src="../../../assets/image/downfile.png" @click="downFile(child.attachment)" /></p>
                            <p v-if="child.fileType=='0'" class="name nowrap" style="width:100%;">{{child.folderName}}</p>
                            <p v-if="child.fileType!='0'" class="name" style="width:100%;">{{child.userName}}上传</p>
                            <p v-if="child.fileType!='0'" class="time" style="width:100%;">{{child.createDate}}</p>
                        </div>
                        <el-button type="primary" @click="addFileFun(item.materiaType)" style="height: 40px;margin-top: 40px;">添加文件夹</el-button>
                        <div style="width:150px;display:flex;flex-wrap:wrap;align-content: flex-start;justify-content: center;align-items: center;padding-top: 45px;">
                            <el-upload
                              class="upload-demo"
                              v-bind:action="uploadUrl"
                              :headers="uploadHead"
                              :data={type:213}
                              :objectBind='item.materiaType'
                              :show-file-list="false"
                              :on-success="fileSuccess1">
                                <el-button size="small" class="primary">点击上传</el-button>
                            </el-upload>
                        </div>
                    </div>
                    <div style="width:150px;" class="flex-wrap item-con">
                        <div style="width:100%;display:flex;flex-wrap:wrap;justify-content: center;" @click="showModel(item.materiaType,1)">
                            <img style="width:64px;height:64px;" src="../../../assets/image/file.png" />
                            <p style="width:100%;">模板文档</p>
                        </div>
                        <div style="width:100%;display:flex;flex-wrap:wrap;justify-content: center;"  @click="showModel(item.materiaType,2)">
                            <img style="width:64px;height:64px;" src="../../../assets/image/file.png" />
                            <p style="width:100%;">原件文档</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-content " v-if="cuid=='1'" style="height: calc( 100% - 100px );">
                <el-table
                    :data="listData"
                    border
                    stripe
                    height="calc( 100% - 50px )"
                    style="width: 100%;"
                >
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column label="序号" width="60">
                        <template slot-scope="scope">
                            <span>{{ scope.row.index }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="项目名称">
                        <template slot-scope="scope">
                            <span>{{ scope.row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="位置">
                        <template slot-scope="scope">
                            <span>{{ scope.row.address }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="描述">
                        <template slot-scope="scope">
                            <span>{{ scope.row.note }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="效果图">
                        <template slot-scope="scope">
                            <el-image v-for="item in scope.row.imgList" :key="item" style="width: 50px; height: 50px" :src="item" :preview-src-list="scope.row.imgList"></el-image>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建人">
                        <template slot-scope="scope">
                            <span>{{ scope.row.userName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间">
                        <template slot-scope="scope">
                            <span>{{ scope.row.createDate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleEdit(scope.$index, scope.row)" style="padding-left:10px;padding-right:10px;">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 表单列表 -->
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[3, 5, 10, 20]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalItems"
                    style="padding-top:10px;padding-bottom: 10px;background: #fff;"
                ></el-pagination>
            </div>
            <div class="box-content" v-if="cuid=='4'">
                <el-table
                    :data="listData1"
                    border
                    stripe
                    height="100%"
                    style="width: 100%;"
                >
                    <template slot="empty">
                        <p>{{dataText1}}</p>
                    </template>
                    <el-table-column label="序号" width="60">
                        <template slot-scope="scope">
                            <span>{{ scope.row.index }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位名称">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isSet">
                                <el-input size="mini" placeholder="请输入内容" v-model="master.entProjectName"></el-input>
                            </span>
                            <span v-else>{{ scope.row.entProjectName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="职务">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isSet">
                                <el-input size="mini" placeholder="请输入内容" v-model="master.positions"></el-input>
                            </span>
                            <span v-else>{{scope.row.positions}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="负责人">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isSet">
                                <el-input size="mini" placeholder="请输入内容" v-model="master.responsiblePerson"></el-input>
                            </span>
                            <span v-else>{{ scope.row.responsiblePerson }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="联系方式">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isSet">
                                <el-input size="mini" placeholder="请输入内容" v-model="master.phone"></el-input>
                            </span>
                            <span v-else>{{ scope.row.phone }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="微信号">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isSet">
                                <el-input size="mini" placeholder="请输入内容" v-model="master.weiXin"></el-input>
                            </span>
                            <span v-else>{{ scope.row.weiXin }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="邮箱">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isSet">
                                <el-input size="mini" placeholder="请输入内容" v-model="master.email"></el-input>
                            </span>
                           <span v-else>{{ scope.row.email }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="el-tag el-tag--info el-tag--mini" style="cursor: pointer;margin-right: 10px;" @click="pwdChange(scope.row,scope.$index,true)">
                                {{scope.row.isSet?'保存':"修改"}}
                            </span>
                            <!-- <span v-if="!scope.row.isSet" class="el-tag el-tag--danger el-tag--mini" style="cursor: pointer;">
                                删除
                            </span> -->
                            <span v-if="scope.row.isSet" class="el-tag  el-tag--mini" style="cursor: pointer;" @click="pwdChange(scope.row,scope.$index,false)">
                                取消
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 新增窗口 -->
            <!-- <el-dialog
                title="添加设计变更及签证"
                width="500px"
                :visible.sync="addFormVisible"
                center
                :append-to-body="true"
                :lock-scroll="false"
                class="add-form"
            >
                <el-form :model="addForm" ref="addForm" :rules="rules" label-width="100px" :label-position="labelPosition">
                    <el-form-item label="编号：" prop="changeNumber">
                        <el-input v-model="addForm.changeNumber" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="变更简述：" prop="changeDescribe">
                        <el-input type="textarea" :rows="2" placeholder="请输入简述内容" v-model="addForm.changeDescribe"></el-input>
                    </el-form-item>
                    <el-form-item label="结果：" prop="changeResults">
                        <el-input type="textarea" :rows="2" placeholder="请输入简述内容" v-model="addForm.changeResults"></el-input>
                    </el-form-item>
                    <el-form-item label="变更时间：">
                        <el-date-picker v-model="addForm.changeTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="addFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                </div>
            </el-dialog> -->
            <!-- 新增文件夹窗口 -->
            <el-dialog
                title="添加文件夹"
                width="500px"
                :visible.sync="addFileVis"
                center
                :append-to-body="true"
                :lock-scroll="false"
                class="add-form"
            >
                <el-form :model="addFile" ref="addFile" label-width="100px" :label-position="labelPosition">
                    <el-form-item label="文件名：">
                        <el-input v-model="addFile.folderName" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="addFileVis = false">取 消</el-button>
                    <el-button type="primary" @click="sumbitAddFile">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
// import PDF from 'pdfjs-dist'
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
    data(){
        return{
            // pageTitle:'',
            labelPosition:'right',
            listData:[],//项目列表
            listData1:[],//通讯录列表
            groupId:"",
            cuid:'48',
            curFile:{
                type:'',
                materiaType:'',
                groupId:'',
                entProjectId:'',
                attachment:'',
                attachmentName:'',
                attachmentType:'',
                userId:'',
                userName:'',
            },
            search:{
                responsiblePerson:'',
                phone:'',
                name:''
            },
            uploadUrl:base.url+"/upload/uploadPhoto",//上传地址
            uploadHead:{  //上传接口header
                accessToken:this.$store.state.token
            },
            entProjectId:'',
            dataList:[],
            pages: [],
            pdfDoc: null,
            addFormVisible:false,
            addForm:{
                id:'',
                changeNumber:'',
                changeDescribe:'',
                changeResults:'',
                changeTime:util.myTime.getCurTime()
            },
            fileName:'',
            wordUrl:'',//word文档地址
            nodeName:[],
            rules:{
                changeNumber: [
                    { required: true, message: '请输入编号', trigger: 'blur' }
                ],
                changeDescribe: [
                    { required: true, message: '请输入简述', trigger: 'blur' }
                ],
                changeResults: [
                    { required: true, message: '请输入结果', trigger: 'blur' }
                ],
            },
            // dataText:'数据加载中...',
            dataText1:'数据加载中...',
            master:{
                id:'',
                // entProjectId:'',
                positions:'',
                responsiblePerson:'',
                phone:'',
                weiXin:'',
                email:'',
                personId:'',
                entProjectName:'',
            },
            isAddFlag:false,
            currentPage: 1,
            pageSize: 10,
            totalItems: 0,
            addFileVis:false, //添加文件夹
            addFile:{
                materiaType:'',
                folderName:''
            },
        }
    },
    mounted() {
        this.groupId = this.$store.state.groupId;
        if(''==this.groupId){
            this.$store.commit('setGroupId');
            this.groupId = this.$store.state.groupId;
        }
        this.entProjectId = this.$route.params.id
        this.fixCuid()
        //this.cuid = this.$route.params.cuid
        //this.getProject()
        this.getData()
    },
    methods:{
        //确定cuid
        fixCuid(){
            var cuid = util.session.get('cuid')
            var result = ''
            var list = [{id:'48',name:'周工作情况'},{id:'49',name:'公共文件夹'},{id:"4",name:'通讯录'}]
            for(var i=0;i<list.length;i++){
                if(cuid==list[i].id){
                    result = list[i].id
                }
            }
            if(result==''){
                this.cuid = '48'
            }else{
                this.cuid = cuid
            }
        },
        doFilter(){
            this.getProject()
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentChangePage()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.currentChangePage();
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getProject();
        },
        //通讯录查询
        doFilterMail(){
            this.getMail()
        },
        //获取数据
        getData(){
            this.getDataByType([])
            var that = this
            myHttp.getAttachmentType({
                type:this.cuid,
                groupId:this.groupId,
                // entProjectId:this.entProjectId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    // that.pageTitle = resp.data.data.project.name
                    // if(that.cuid=='48'){
                    //     that.pageTitle += ' - 周工作情况'
                    // }else if(that.cuid=='49'){
                    //     that.pageTitle += ' - 公共文件夹'
                    // }
                    that.getDataByType(resp.data.data)
                }
            })
        },
        //获取项目
        getProject(){
            var that = this
            this.search.groupId = this.groupId
            this.search.pageNum = this.currentPage
            this.search.pageSize = this.pageSize
            myHttp.getEntProjectList(this.search).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.entProject.list;
                    for(var i=0;i<list.length;i++){
                        list[i].index = list[i].index = ((that.currentPage - 1) * that.pageSize)+(i+1);
                        var img = list[i].effectImage&&list[i].effectImage!=''?list[i].effectImage.split(','):[]
                        for(var j=0;j<img.length;j++){
                            img[j] = base.httpCtx+img[j]
                        }
                        list[i].imgList = img
                    }
                    that.listData = list;
                    that.totalItems = resp.data.data.entProject.total
                    if(that.listData.length==0){
                        that.dataText = "暂无数据"
                    }
                }
            })
        },
        //获取通讯录
        getMail(){
            var that = this
            this.search.entProjectId = this.entProjectId 
            myHttp.selectAddressBookList(this.search).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.addressBook||[];
                    for(var i=0;i<list.length;i++){
                        list[i].index = i+1
                        //list[i].entProjectName = that.entProjectName
                        list[i].isSet = false
                    }
                    that.listData1 = list;
                    if(that.listData1.length==0){
                        that.dataText1 = "暂无数据"
                    }
                }else{
                    that.dataText1 = "暂无数据"
                }
            })
        },
        //根据type展示数据
        getDataByType(data){
            var dataList = [];
            // var nodeCode = [
            //     [{id:'1',val:'list1'},{id:'2',val:'list2'},{id:'3',val:'list3'}],
            //     [{id:'1',val:'list1'},{id:'2',val:'list2'}],
            //     [{id:'1',val:'list1'},{id:'2',val:'list2'},{id:'3',val:'list3'},{id:'4',val:'list4'}],
            //     [{id:'1',val:'list1'},{id:'2',val:'list2'}],
            //     [{id:'1',val:'list1'}],
            //     [{id:'1',val:'list1'}],
            //     [{id:'1',val:'list1'},{id:'2',val:'list2'}],
            //     [{id:'1',val:'list1'}],
            //     [{id:'1',val:'list1'},{id:'2',val:'list2'},{id:'3',val:'list3'},{id:'4',val:'list4'}],
            //     [{id:'1',val:'list1'},{id:'2',val:'list2'}],
            //     [{id:'1',val:'list1'},{id:'2',val:'list2'}]
            // ]
            // var str = nodeCode[parseInt(this.cuid)-1]
            //for(var i=0;i<str.length;i++){
                var list = data['list1']||[]
                var obj = {}
                if(list.length==0){
                    obj = {
                        attachments:[],
                        materiaType:'1'
                    }
                }else{
                    obj = list[0]
                    var li = obj.attachments||[]
                    for(var j=0;j<obj.attachments.length;j++){
                        //obj.attachments[j].fileType = this.getImg(obj.attachments[j].attachment)
                        obj.attachments[j].fileType = obj.attachments[j].attachment&&''!=obj.attachments[j].attachment?this.getImg(obj.attachments[j].attachment):'0'
                    }
                }
                //obj.name = this.getNameByType(obj.materiaType)
                dataList.push(obj)
            //}
            this.dataList = dataList
        },
        //获取节点名称
        getNameByType(type){
            var result = ''
            var list = this.nodeName[parseInt(this.cuid)-1]
            for(var i=0;i<list.length;i++){
                if(list[i].id==type){
                    result = list[i].name
                }
            }
            return result
        },
        //获取图片
        getImg(url){
            // 1:word   2:excel    3:pdf     4:img   5:undefined
            var result = '';
            var list = url.split('.')
            var str = list[list.length-1]
            if(base.docType.indexOf(str)>=0){
                result = '1'
            }else if(base.imgType.indexOf(str)>=0){
                result = '4'
            }else if(base.excelType.indexOf(str)>=0){
                result = '2'
            }else if(base.pdfType.indexOf(str)>=0){
                result = '3'
            }else{
                result = '5'
            }
            return result
        },
        //导出
        // exportOut(){
        //     var token = this.$store.state.token;
        //     window.open(myHttp.getExportInspectsByGroupId+'?groupId='+this.groupId+'&unit='+this.search.unit+'&date='+this.search.date+'&accessToken='+token)
        // },
        //查看
        handleEdit(index,row){
            // this.$router.push('/checkDetail/'+row.id+'/'+row.type)
            this.$router.push('/saleFile/'+row.id)
        },
        
        //展示
        setCuid(row){
            this.cuid = row
            util.session.set('cuid',this.cuid)
            if(row=='1'){
                this.getProject()
            }else if(row=='4'){
                this.getMail()
            }else{
                this.getData()
            }
            
        },
        //获取变更数据
        // getListData(){
        //     var that = this
        //     myHttp.getAttachmentTypeList({
        //         type:this.cuid,
        //         groupId:this.groupId,
        //         entProjectId:this.entProjectId
        //     }).then(function(resp){
        //         if(resp.data.code=='200'){
        //             var list = resp.data.data.entity||[]
        //             that.listData = list
        //             if(list.length==0){
        //                 that.dataText = "暂无数据"
        //             }
        //         }else{
        //             that.$message.error(resp.data.msg);
        //         }
                
        //     },function(){})
        // },
        //返回
        goBack(){
            this.$router.go(-1);
        },
        /**申报材料 */
        //上传成功
        fileSuccess1(res,file,opt,index){
            //console.log(index)
            if(res.code==200){
                this.curFile.type = this.cuid
                this.curFile.materiaType = index
                this.curFile.groupId = this.groupId
                this.curFile.entProjectId = this.entProjectId
                this.curFile.attachment = res.data.saveUrls
                var name = file.name.split('.')
                name.pop()
                name = name.join();
                this.curFile.attachmentName = name
                this.curFile.userId = this.$store.state.user.id
                this.curFile.userName = this.$store.state.user.name
                this.curFile.attachmentType = 3
                //this.curFile.parentId = this.id1
                this.submitFun(this.curFile)

                // let that = this
                // this.$confirm('请选择文档类型?', '信息', {
                //     distinguishCancelAndClose: true,
                //     confirmButtonText: '模板文档',
                //     cancelButtonText: '原件文档',
                //     type: 'info'
                // }).then((resp) => {
                //     that.curFile.attachmentType = 1
                //     that.submitFun(that.curFile)
                // }).catch(err => {
                //     if(err=='cancel'){
                //         that.curFile.attachmentType = 2
                //         that.submitFun(that.curFile)
                //     }
                // })
                
            }else{
                this.$message.error(res.msg);
            }
            
        },

        /**
         * 添加方法
         */
        submitFun(data){
            let that = this
            // window.open(base.fileView+'/addTask?url='+base.httpCtx+data.attachment);
            myHttp.postAttachment(data).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message({type: 'success',message: '文件添加成功!'});
                    that.getData()
                }else{
                    that.$message.error(resp.data.msg);
                }
            })
        },
        //查看文档
        showFile(url,name){
            var that = this
            //if (!/.(pdf|PDF)$/.test(url)) {
                //window.open( "http://view.officeapps.live.com/op/view.aspx?src=" +base.netCtx+ url, "_blank");
                // window.open( "http://view.officeapps.live.com/op/embed.aspx?src=" +base.netCtx+ url, "_blank");
                // console.log(url)
                //window.open('http://file.tongsheng01.com:8012/onlinePreview?url='+encodeURIComponent(base.httpCtx+url),"_blank");
                window.open(base.fileView+'/onlinePreview?url='+encodeURIComponent(base.httpCtx+url),"_blank");
            // }else{
            //     myHttp.getAttachmentFtp({
            //         fileUrl:base.httpCtx,
            //         fileName:url
            //     }).then(function(resp){
            //         if(resp.data.code=='200'){
            //             that.addFormVisible = true
            //             that.fileName = name
            //             var url = resp.data.data.buff
            //             that.loadFile(url)
            //         }else{
            //             that.$message.error(resp.data.msg);
            //         }
            //     })
            // }
        },
        // 新增的数据
        sumbitAddRow(formName) {
            var that = this;
            // this.addForm.userId = this.$store.state.user.id
            // this.addForm.userName = this.$store.state.user.name
            this.addForm.groupId = this.groupId
            this.addForm.entProjectId = this.entProjectId,
            this.addForm.type = this.cuid
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(that.addForm.id==''){
                        myHttp.postChange(that.addForm).then(function(resp){
                            if(resp.data.code=="200"){
                                that.$message.success("添加成功");
                                that.addFormVisible = false;
                                that.getListData();
                            }else{
                                that.$message.error(resp.data.msg);
                            }
                        },function(){})
                    }else{
                        // myHttp.putEntProject(that.addForm).then(function(resp){
                        //     if(resp.data.code=="200"){
                        //         that.$message.success("添加成功");
                        //         that.addFormVisible = false;
                        //         that.currentPage = 1;
                        //         that.getData();
                        //     }else{
                        //         that.$message.error(resp.data.msg);
                        //     }
                        // },function(){});
                    }
                }
            });
        },
        //下载文档
        downFile(url){
            window.open(base.httpCtx+url)
        },
        //查看模板
        showModel(id,type){
            this.$router.push('/folderRules/'+this.cuid+'/'+id+'/'+type+'/'+this.entProjectId)
            
        },
        //查看原件
        showWord(id,type){
            this.$router.push('/desModel/'+this.cuid+'/'+id+'/'+type)
           
        },

        //添加
        addQin(){
            if(this.isAddFlag){
                this.$message.warning("请先保存当前台账");
                return
            }else if(this.master.id!=''){
                this.$message.warning("请先保存当前编辑项");
                return
            }
            this.isAddFlag = true
            this.master = {
                id:'',
                entProjectName:'',
                positions:'',
                responsiblePerson:'',
                phone:'',
                weiXin:'',
                email:'',
                //entProjectId:this.entProjectId,
                personId:util.session.get('user').id,
                isSet:true
            }
            this.listData1.push(this.master)
        },

        //修改
        pwdChange(row, index, cg) {
            //点击修改 判断是否已经保存所有操作
            var that = this
            //for (let i of this.master) {
            if (this.master.id!='' && this.master.id != row.id||(this.isAddFlag&&cg&&!row.isSet)) {
                this.$message.warning("请先保存当前编辑项");
                return false;
            }
            //}
            //是否是取消操作
            if (!cg) {
                //if (!app.master_user.sel.id) app.master_user.data.splice(index, 1);
                this.getMail()
                this.master={
                    id:'',
                    positions:'',
                    responsiblePerson:'',
                    phone:'',
                    weiXin:'',
                    email:'',
                    entProjectName:'',
                    personId:util.session.get('user').id,
                }
                this.isAddFlag = false
                return row.isSet = !row.isSet;
            }
            //提交数据
            if (row.isSet) {
                //项目请求操作
                var that = this
                
                if(this.master.id==''){
                    myHttp.postAddressBook(this.master).then(function(resp){
                        if(resp.data.code=='200'){
                            that.isAddFlag = false
                            that.$message.success('添加成功');
                            that.getMail()
                        }else{
                            that.$message.error(resp.data.msg);
                        }
                    })
                }else{
                    myHttp.putAddressBook(this.master).then(function(resp){
                        if(resp.data.code=='200'){
                            that.$message.success('保存成功');
                            that.getMail()
                            that.master={
                                id:'',
                                positions:'',
                                responsiblePerson:'',
                                phone:'',
                                weiXin:'',
                                email:'',
                                entProjectName:'',
                                //entProjectId:this.entProjectId,
                                personId:util.session.get('user').id,
                            }
                        }else{
                            that.$message.error(resp.data.msg);
                        }
                    })
                }
            } else {
                this.master = {
                    id:row.id,
                    positions:row.positions,
                    responsiblePerson:row.responsiblePerson,
                    phone:row.phone,
                    weiXin:row.weiXin,
                    email:row.email,
                    //entProjectId:this.entProjectId,
                    personId:util.session.get('user').id,
                    entProjectName:this.entProjectName,
                }
                row.isSet = true;
            }
        },
        //添加方法
        addFileFun(index){
            this.addFileVis = true
            this.addFile.materiaType = index
        },
        //添加文件夹
        sumbitAddFile(){
            var that = this
            if(this.addFile.folderName==''){
                this.$message.error('请输入文件名称');
                return
            }
            this.addFile.type = this.cuid
            //this.addForm.materiaType = this.materiaType
            this.addFile.groupId = this.groupId
            this.addFile.entProjectId = this.entProjectId
            //this.addFile.parentId = ''
            this.addFile.attachmentType = '3'
            this.addFile.userId = util.session.get('user').id
            this.addFile.userName = util.session.get('user').name
            myHttp.postAttachment(this.addFile).then(function(resp){
                //console.log(resp)
                if(resp.data.code=='200'){
                    that.$message.success('添加成功');
                    that.addFileVis = false
                    that.getData()
                }else{
                    that.$message.error(resp.data.msg);
                }
            })
        },
        //查看文档下面的文件
        showChild(id){
            this.$router.push('/desModel/'+this.cuid+'/'+this.materiaType+'/3/'+this.entProjectId+'/'+id)
            // this.$router.push('/desFileModel/'+id)
        },

    }
}
</script>
<style scoped>
    .contain{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header-box{
        padding: 15px 20px;
        height: 70px;
        width: 100%;
        box-shadow: 1px 2px 3px 2px #ddd;
        background: #fff;
        box-sizing: border-box;
        position: relative;
        text-align: left;
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #2058D9;
    }
    .box{
        margin-top: 15px;
        width: 100%;
        height: calc( 100% - 70px );
    }
    .box-content{
        width: 100%;
        height: calc( 100% - 80px );
        /* background: #fff; */
        overflow: auto;
        /* display: flex;
        align-content: flex-start; */
    }
    .build-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 80px;
        background: #fff;
        border-bottom: 3px solid #17b2fe;
        padding: 0 20px;
    }
    .el-button{
        background: #FFF;
        border: 1px solid #DCDFE6;
        color: #606266;
    }
    .primary{
        background-color: #17b2fe;
        border-color: #17b2fe;
        color: #fff;
    }
    .table-item{
        width: 100%;
        min-height: 50px;
        display: flex;
        /* border-bottom: 15px solid #ecf0f5; */
        background: #fff;
    }
    .flex-wrap{
        display: flex;
        flex-wrap: wrap;
    }
    .item-con{
        padding: 10px;
    }
    .item-con p{
        margin: 0;
        margin-bottom: 15px;
        width: 100%;
        text-align: center;
        font-size: 14px;
    }
    .item-con img{
        cursor: pointer;
    }
    .table-item-sec{
        width: 100%;
        height: 50px;
        background: #17B2FE;
        color: #fff;
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 15px solid #ecf0f5;
    }
    .nowrap {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
</style>
<style>
    .build-bar span{
        margin-left: 0;
    }
    .el-table td, .el-table th{
        text-align: center;
    }
    /* .el-dialog{
        width: 500px;
    } */
</style>